import sliceCreator from '../../index.js';
import {GET_USER} from '../../../constants/index.js';
const _getUserAction = sliceCreator('GET_USER', GET_USER, 'get');

const { asyncAction: getUserAction, reducer, clearData: clearGetUserAction } = _getUserAction;

export default reducer;

export {
    getUserAction,
    clearGetUserAction
}